import React, {Component} from 'react';
import Validator from '../../helpers/validator';
import {PaymentAction} from '../../actions';
import {connect} from 'react-redux';
import Utility from "../../helpers/Utility";
import NotFound from "../NotFound";
import Animate from "../Animate";
import { Player } from "@lottiefiles/react-lottie-player";
import successful from "../../assets/raw/successful.json";
import locked from "../../assets/raw/locked.json";
import PayoutDataInput from "../layout/PayoutDataInput";

/* ── Icons ── */
const LockIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
);
const CopyIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
);
/* Per-method icons */
const BankTransferIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="22" x2="21" y2="22"/>
        <line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/>
        <line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/>
        <polygon points="12 2 20 7 4 7"/>
    </svg>
);
const AirtimeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
);
const DataIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.55a11 11 0 0 1 14.08 0"/>
        <path d="M1.42 9a16 16 0 0 1 21.16 0"/>
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
        <line x1="12" y1="20" x2="12.01" y2="20"/>
    </svg>
);
const CableTvIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
        <polyline points="17 2 12 7 7 2"/>
    </svg>
);
const UtilityIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
    </svg>
);

const methodTabs = [
    { key: 'bank_transfer', label: 'Bank Transfer',    Icon: BankTransferIcon },
    { key: 'airtime',       label: 'Airtime Purchase', Icon: AirtimeIcon },
    { key: 'data',          label: 'Data Purchase',    Icon: DataIcon },
    { key: 'cabletv',       label: 'Cable Purchase',   Icon: CableTvIcon },
    { key: 'utility',       label: 'Utility Purchase', Icon: UtilityIcon },
];

class ClaimPayout extends Component {
    state = {
        error: {},
        stage: 1,
        channel: 'bank_transfer',
        copiedText: null,
    };

    componentDidMount() {
        const { dispatch, match: { params: { id } } } = this.props;
        dispatch(PaymentAction.fetchPaymentData(id));
    }

    componentDidUpdate(prevProps) {
        const { claimPayout } = this.props;
        // When a claimPayout response arrives, spread any server field errors into state
        if (claimPayout?.data !== prevProps.claimPayout?.data) {
            const data = claimPayout?.data;
            if (data?.status === false && data?.errors && Object.keys(data.errors).length > 0) {
                this.setState(prev => ({ error: { ...prev.error, ...data.errors } }));
            }
        }
    }

    handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copiedText: text });
            setTimeout(() => this.setState({ copiedText: null }), 2000);
        }).catch(err => console.error(err));
    };

    submit = (e) => {
        e.preventDefault();
        const validator = new Validator(e);
        validator.remove('amount');

        if (this.state.stage === 1) {
            validator.validate('firstname').isUsername("Please enter a valid first name");
            validator.validate('lastname').isUsername("Please enter a valid last name");
            validator.validate('email').isEmail("Please enter a valid email address");
            validator.validate('claim_code')
                .isBlank("Please enter a valid claim code")
                .isAlphaNumeric("Claim code must be alphanumeric")
                .hasMinLength(6, "Claim code must be at least 6 digits")
                .hasMaxLength(6, "Claim code must be at most 6 digits");
        } else if (this.state.stage === 2) {
            if (this.state.channel === 'bank_transfer') {
                validator.validate('bank_code').isBlank("Please select a bank");
                validator.validate('account_number')
                    .isBlank("Please enter an account number")
                    .isNumber("Account number must be numeric")
                    .hasMinLength(10, "Account number must be at least 10 digits")
                    .hasMaxLength(10, "Account number must be at most 10 digits");
            } else if (this.state.channel === 'airtime') {
                validator.validate('category_id').isBlank("Please select a vendor");
                validator.validate('entity_number')
                    .isBlank("Please enter a phone number")
                    .isPhoneNumber("Please enter a valid phone number");
            }
        }

        if (validator.hasError()) {
            this.setState({ error: { ...validator.getErrorsFlat() } });
        } else {
            this.setState({ error: {} });
            const { dispatch, match: { params: { id } } } = this.props;
            // getFormData() captures ALL form fields, including hidden stage-1 inputs
            const formData = validator.getFormData();

            if (this.state.stage === 1) {
                dispatch(PaymentAction.confirmClaimCode(id, formData.claim_code)).then(() => {
                    const { confirmClaimCode } = this.props;
                    if (confirmClaimCode?.data?.status) {
                        this.setState({ stage: 2 });
                    } else {
                        const serverErrors = confirmClaimCode?.data?.errors;
                        if (serverErrors && Object.keys(serverErrors).length > 0) {
                            // Show server field-level errors inline under their inputs
                            this.setState(prev => ({ error: { ...prev.error, ...serverErrors } }));
                        } else {
                            this.setState({ error: { claim_code: confirmClaimCode?.data?.message || 'Invalid claim code' } });
                        }
                    }
                });
            } else if (this.state.stage === 2) {
                // formData contains firstname, lastname, email, claim_code (from hidden inputs) + stage-2 fields
                dispatch(PaymentAction.claimPayout(id, formData));
            }
        }
    };

    render() {
        const { error, stage, channel, copiedText } = this.state;
        const { paymentData, confirmClaimCode, claimPayout } = this.props;
        const claimPayoutData = claimPayout?.data;
        const payment = paymentData?.data?.data?.payment;

        if (paymentData.requesting || !('status' in (paymentData.data || {}))) {
            // Network / parse error — data has no `status` key but we are no longer requesting
            if (!paymentData.requesting && paymentData.data?.message) {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '40vh', gap: '1rem', padding: '2rem', textAlign: 'center' }}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="12" y1="8" x2="12" y2="12"/>
                            <line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                        <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', maxWidth: 360, margin: 0 }}>
                            {paymentData.data.message}
                        </p>
                        <button className="ps-btn-primary" style={{ maxWidth: 200 }}
                            onClick={() => {
                                const { dispatch, match: { params: { id } } } = this.props;
                                dispatch(PaymentAction.fetchPaymentData(id));
                            }}>
                            Try Again
                        </button>
                    </div>
                );
            }
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
                    <span className="ps-spinner ps-spinner-dark" style={{ width: 32, height: 32 }} />
                </div>
            );
        }

        if (paymentData && paymentData?.data?.status === false) return <NotFound message={paymentData?.data?.message}/>;
        if (payment && payment?.direction !== 'payout') return <NotFound message="Invalid payout link"/>;

        return (
            <div style={{ width: '100%' }}>
                {/* Page header */}
                <div className="ps-page-header">
                    <span className="ps-badge"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{display:"inline",verticalAlign:"middle",marginRight:"4px",marginBottom:"1px"}}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>PAYOUT CLAIM</span>
                    <p className="ps-page-title">
                        Claim payout from{' '}
                        {paymentData.requesting
                            ? <span className="ps-spinner ps-spinner-dark" style={{ width: 14, height: 14, display: 'inline-block', verticalAlign: 'middle' }} />
                            : <strong>{payment?.company?.name || payment?.user?.name}</strong>}
                    </p>
                </div>

                <div className="ps-checkout-grid">
                    {/* ── Left: summary ── */}
                    <div className="ps-info-stack">
                        <div className="ps-card">
                            <div className="ps-card-body">
                                <div className="ps-card-header">
                                    <div className="ps-card-header-left">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                                            <line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>
                                        </svg>
                                        Payout Summary
                                    </div>
                                </div>
                                {paymentData.requesting ? (
                                    <div style={{ marginTop: '1rem' }}>
                                        <div className="ps-shimmer" style={{ width: '70%', marginBottom: '0.5rem' }} />
                                        <div className="ps-shimmer ps-shimmer-sm" />
                                    </div>
                                ) : (
                                    <div style={{ paddingTop: '0.25rem' }}>
                                        <p className="ps-payment-detail">{payment?.title}</p>
                                        <p className="ps-payment-desc">{payment?.description}</p>
                                        <div className="ps-amount-row">
                                            <span className="ps-amount-label">Payout Amount</span>
                                            <span className="ps-amount-value">
                                                {Utility.moneyFormat(payment?.amount || 0, 2, 'currency', payment?.currency)}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Step indicator */}
                        <div className="ps-card">
                            <div className="ps-card-body">
                                <Animate animKey={stage} enter="ps-anim-fade-in" exit="ps-anim-fade-out" duration={150}>
                                <div className="ps-stage-indicator">
                                    <div className={`ps-stage-dot ${payment?.is_claimed ? 'pending' : stage > 1 ? 'done' : 'active'}`}>
                                        {stage > 1 ? '✓' : '1'}
                                    </div>
                                    <div className={`ps-stage-line ${stage > 1 || claimPayoutData?.status === true ? 'done' : ''}`} />
                                    <div className={`ps-stage-dot ${claimPayoutData?.status === true ? 'done' : stage === 2 ? 'active' : 'pending'}`}>{claimPayoutData?.status === true ? '✓' : '2'}</div>
                                </div>
                                {!payment?.is_claimed && (
                                    <p className="ps-stage-desc">
                                        {stage === 1 ? 'Step 1: Verify your identity' : 'Step 2: Provide payout details'}
                                    </p>
                                )}
                                </Animate>
                            </div>
                        </div>
                    </div>

                    {/* ── Right: payment panel ── */}
                    <div className="ps-payment-panel">
                        <div className="ps-payment-inner">
                            {/* Method tabs — disabled on stage 1 */}
                            <div className="ps-method-selector">
                                <span className="ps-method-label">Payout Methods</span>
                                {methodTabs.map(({ key, label, Icon }) => (
                                    <button key={key} type="button"
                                        className={`ps-method-btn ${channel === key ? 'active' : ''}`}
                                        onClick={() => { if (claimPayoutData?.status || payment?.is_claimed) return; this.props.dispatch(PaymentAction.resetClaimPayout()); this.setState({ channel: key, error: {} }); }}
                                        disabled={!!(claimPayoutData?.status || payment?.is_claimed)}
                                        style={{ opacity: 1 }}>
                                        <Icon />
                                        {label}
                                    </button>
                                ))}
                            </div>

                            {/* Form area */}
                            <div className="ps-form-panel">
                                <Animate
                                    animKey={`${stage}-${claimPayoutData?.status}-${payment?.is_claimed}`}
                                    enter={stage === 2 ? 'ps-anim-slide-in-right' : 'ps-anim-slide-in-left'}
                                    exit={stage === 2 ? 'ps-anim-slide-out-left' : 'ps-anim-slide-out-left'}
                                    duration={200}
                                    style={{ flex: 1 }}
                                >
                                {/* ── Success / already-claimed screen ── */}
                                {(claimPayoutData?.status || payment?.is_claimed) ? (
                                    <div className="ps-status-screen">
                                        <Player autoplay loop
                                            src={payment?.is_claimed ? locked : successful}
                                            style={{ height: 130, width: 130 }} />
                                        <h4 className={`ps-status-title ${payment?.is_claimed ? '' : 'success'}`}
                                            style={{ color: payment?.is_claimed ? 'var(--text-secondary)' : undefined }}>
                                            {payment?.is_claimed ? 'Already Claimed' : 'Success!'}
                                        </h4>
                                        <p className="ps-status-subtitle">
                                            {payment?.is_claimed
                                                ? 'This payout has already been claimed.'
                                                : (claimPayoutData?.message ?? 'Payout claimed successfully')}
                                        </p>

                                        {/* Meter token */}
                                        {!claimPayout.requesting && claimPayoutData?.status && claimPayoutData?.data?.payment?.meta?.token && (
                                            <div className="ps-bank-details" style={{ width: '100%', maxWidth: 360, marginBottom: '1.5rem' }}>
                                                <div className="ps-bank-detail-row">
                                                    <span className="ps-bank-detail-key">Meter Token</span>
                                                    <span className="ps-bank-detail-val">
                                                        <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700 }}>
                                                            {claimPayoutData?.data?.payment?.meta?.token}
                                                        </span>
                                                        {copiedText === claimPayoutData?.data?.payment?.meta?.token
                                                            ? <span className="ps-copied-badge">Copied!</span>
                                                            : <button type="button" className="ps-copy-btn"
                                                                onClick={() => this.handleCopy(claimPayoutData?.data?.payment?.meta?.token)}>
                                                                <CopyIcon />
                                                              </button>
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        <button type="button" className="ps-btn-primary" style={{ maxWidth: 240 }}
                                            onClick={() => { if (window.opener) window.close(); else window.history.back(); }}>
                                            Close Page
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        {/* API error — only show the banner when there are no field-level errors to display inline */}
                                        {!claimPayout.requesting && claimPayoutData?.status === false &&
                                         (!claimPayoutData?.errors || Object.keys(claimPayoutData.errors).length === 0) && (
                                            <Animate
                                                animKey="error"
                                                enter="ps-anim-slide-in-down"
                                                exit="ps-anim-slide-out-up"
                                                duration={200}
                                            >
                                                <div className="ps-alert ps-alert-danger">{claimPayoutData?.message}</div>
                                            </Animate>
                                        )}

                                        {/*
                                          SINGLE FORM — both stages.
                                          Stage-1 fields are ALWAYS in the DOM.
                                          When stage === 2, they are hidden via CSS (ps-hidden-stage).
                                          This preserves their values so validator.getFormData() on stage-2
                                          submit includes firstname, lastname, email, claim_code — matching
                                          the original Bootstrap d-none pattern exactly.
                                        */}
                                        <form onSubmit={this.submit}>
                                            {/* ── Amount (stage 1 only, purely visual) ── */}
                                            <div className={stage === 2 ? 'ps-hidden-stage' : 'ps-form-group'}>
                                                <label className="ps-label">Amount</label>
                                                <div style={{ display: 'flex', alignItems: 'stretch' }}>
                                                    <span className="ps-input-addon-token">
                                                        {paymentData.requesting
                                                            ? <span className="ps-spinner ps-spinner-dark" style={{ width: 14, height: 14 }} />
                                                            : payment?.currency}
                                                    </span>
                                                    <input className="ps-input ps-input-attached"
                                                        value={Utility.numberFormat(payment?.amount || 0)}
                                                        readOnly name="amount" />
                                                </div>
                                            </div>

                                            {/* ── Stage-1 identity fields ── hidden via CSS on stage 2 so values persist ── */}
                                            <div className={stage === 2 ? 'ps-hidden-stage' : ''}>
                                                <div className="ps-form-row" style={{ marginBottom: '1rem' }}>
                                                    <div className="ps-form-group" style={{ marginBottom: 0 }}>
                                                        <label className="ps-label" htmlFor="cp-firstname">First Name</label>
                                                        <input className={`ps-input${error.firstname ? ' is-invalid' : ''}`}
                                                            type="text" id="cp-firstname" name="firstname" placeholder="Enter first name" />
                                                        {error.firstname && <span className="ps-error-text">{error.firstname}</span>}
                                                    </div>
                                                    <div className="ps-form-group" style={{ marginBottom: 0 }}>
                                                        <label className="ps-label" htmlFor="cp-lastname">Last Name</label>
                                                        <input className={`ps-input${error.lastname ? ' is-invalid' : ''}`}
                                                            type="text" id="cp-lastname" name="lastname" placeholder="Enter last name" />
                                                        {error.lastname && <span className="ps-error-text">{error.lastname}</span>}
                                                    </div>
                                                </div>

                                                <div className="ps-form-row">
                                                    <div className="ps-form-group" style={{ marginBottom: 0 }}>
                                                        <label className="ps-label" htmlFor="cp-email">Email Address</label>
                                                        <input className={`ps-input${error.email ? ' is-invalid' : ''}`}
                                                            type="email" id="cp-email" name="email" placeholder="Enter email" />
                                                        {error.email && <span className="ps-error-text">{error.email}</span>}
                                                    </div>
                                                    <div className="ps-form-group" style={{ marginBottom: 0 }}>
                                                        <label className="ps-label" htmlFor="cp-claim-code">Claim Code</label>
                                                        <input className={`ps-input${error.claim_code ? ' is-invalid' : ''}`}
                                                            type="text" id="cp-claim-code" name="claim_code" placeholder="6-digit code"
                                                            maxLength={6} />
                                                        {error.claim_code && <span className="ps-error-text">{error.claim_code}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ── Stage-2 payout fields ── */}
                                            {stage === 2 && (
                                                <PayoutDataInput error={error} stage={stage} channel={channel} />
                                            )}

                                            <input type="hidden" name="channel" value={channel} />

                                            <button type="submit" className="ps-btn-primary"
                                                disabled={confirmClaimCode.requesting || claimPayout.requesting}>
                                                {(confirmClaimCode.requesting || claimPayout.requesting)
                                                    ? <span className="ps-spinner" />
                                                    : <><LockIcon /><span>{stage === 1 ? 'Proceed' : 'Claim Payout'}</span></>
                                                }
                                            </button>
                                        </form>
                                    </>
                                )}
                                </Animate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    paymentData:       state.paymentData,
    confirmClaimCode:  state.confirmClaimCode,
    claimPayout:       state.claimPayout,
}))(ClaimPayout);
